import styled, { css } from 'styled-components';

const StyledDropdownMenu = styled.div `
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
    min-width: 128px;
    ${({ width }) => width
    ? css `
                  width: ${width}!important;
              `
    : css `
                  width: fit-content !important;
              `}
    ${({ maxWidth }) => maxWidth &&
    css `
            max-width: ${maxWidth};
        `}
        display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
    ${({ isOpen }) => isOpen &&
    css `
            box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1);
            padding: 8px;
            box-sizing: border-box;
            li:not(.divider) {
                box-sizing: border-box;
                border-radius: 6px;
                display: block;
                text-decoration: none;
                margin-bottom: 2px;
                color: #111827;
                font-weight: 400;
                font-size: 14px;
                a,
                .menu-item-content-wrapper {
                    padding: 8px;
                }
                a {
                    box-sizing: border-box;
                    border-radius: 6px;
                    color: inherit;
                    display: flex;
                    justify-content: space-between;
                    text-decoration: none;
                    white-space: nowrap;
                }
                &.helix-unified-nav__notification-menu-item a {
                    white-space: initial;
                }

                &.highlighted {
                    background-color: #f3f4f6;
                }
                &.helix-dropdown-menu__overflow-dropdown-item {
                    display: flex;
                    align-items: center;
                }
                &.helix-dropdown-menu__sub-menu-item {
                    padding-left: 16px;

                    &--closed {
                        display: none;
                    }
                }

                &.disabled {
                    opacity: 0.5;
                    cursor: pointer;
                    pointer-events: none;
                }

                .dropdown-menu-item-content {
                    display: grid;
                    align-items: center;
                    justify-content: space-between;
                    grid-template-columns: 1fr 20px;
                    gap: 12px;
                    flex: 1 1;
                    .checkmark-outlined {
                        fill: #2563eb !important;
                        path {
                            fill: #2563eb !important;
                        }
                    }
                }
            }
        `}
    &:focus-within {
        outline: none;
    }
    ul {
        padding: 0;
        margin: 0;
        list-style: none;
        ${({ inNavbar }) => inNavbar &&
    css `
                max-height: calc(100vh - 150px);
                overflow: auto;
            `}
        &:focus-visible {
            outline: none;
        }
        li {
            &:not(.divider):not(.section-header):not(.disabled) {
                cursor: pointer;
            }
            display: flex;
            .menu-item-content-wrapper {
                display: flex;
                flex: 1 1;
                justify-content: space-between;
                align-items: center;
                .menu-item-label {
                    flex: 1 1;
                }
            }
            &.disabled .menu-item-content-wrapper,
            &:disabled .menu-item-content-wrapper {
                *:not(.not-active) {
                    .label,
                    .description {
                        opacity: 0.6;
                    }
                }
            }
            &.selected-item {
                outline-width: 0;
                background-color: #e5e7eb;
            }
            &.active {
                color: #111827;
                background-color: #e5e7eb;
            }
        }
        .divider {
            padding: 0;
            margin: 6px 0;
            overflow: hidden;
            border-top: 1px solid #e5e7eb;
        }
        .section-header {
            text-transform: uppercase;
            font-size: 12px;
            color: #4b5563;
            letter-spacing: 0.1em;
            padding: 8px;
            &.section-header-bold {
                font-weight: 600;
            }
            .menu-item-content-wrapper {
                padding: 0;
            }
        }
        .description {
            color: #4b5563;
            font-size: 12px;
        }
        + ul {
            margin-left: 16px;
            @media screen and (max-width: 576px) {
                margin-left: 0;
                margin-top: 16px;
            }
        }
    }
    .empty-state {
        padding: 8px;
        text-align: center;
    }
`;

export { StyledDropdownMenu };
//# sourceMappingURL=DropdownMenu.styles.js.map
